import React from "react";

export default function EidAlFitrFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-eid31{fill:#0c0c28}.cls-eid32{fill:#15133c}"}</style>
        </defs>
        <path
          d="M1425.5 570c-95.4-178.56-315.74-122.57-412.41-329.28a380.754 380.754 0 0 1-14.41-35.34c-.68 2.54-1.57 5.73-2.7 9.46a323.38 323.38 0 0 1-9.08 25.88C906.36 442.08 672.37 386.81 574.5 570c-56.83 106.37-32.78 216.64-30.3 227.24 13.98 59.96 43.61 103.63 64.92 129.62h-33.03v50.5h35.81v892.17h775.62V977.36h36.95v-50.5h-33.6c21.31-25.99 50.94-69.66 64.92-129.62 2.48-10.6 26.53-120.87-30.29-227.24Zm-83.3 1253.42H657.79v-684.41h684.41v684.41Z"
          className="cls-eid32"
        />
        <path
          d="M1042.28 172.75c0 23.35-18.93 42.29-42.28 42.29s-42.28-18.93-42.28-42.29c0-23.35 18.93-42.28 42.28-42.28 1.81 0 3.59.11 5.33.33-15.63 2.26-27.64 15.71-27.64 31.96 0 17.83 14.46 32.29 32.29 32.29 16.25 0 29.7-12.01 31.96-27.63.22 1.75.33 3.53.33 5.33Z"
          className="cls-eid32"
        />
        <path
          d="M576.09 926.86h848.38v51.69H576.09zM790.08 268.77l12.03 24.36 26.89 3.91L809.54 316l4.59 26.78-24.05-12.64-24.05 12.64 4.6-26.78-19.46-18.96 26.89-3.91 12.02-24.36zM1165.91 141.02l12.03 24.36 26.89 3.91-19.46 18.97 4.59 26.78-24.05-12.65-24.05 12.65 4.6-26.78-19.46-18.97 26.89-3.91 12.02-24.36zM1232.18 338.75l8.46 17.13 18.9 2.74-13.68 13.34 3.23 18.82-16.91-8.88-16.9 8.88 3.23-18.82-13.68-13.34 18.9-2.74 8.45-17.13z"
          className="cls-eid31"
        />
        {children}
      </g>
    </svg>
  );
}
